import axios from 'axios'
import router from '@/router'

const service = axios.create({ timeout: 30000 })

function gotoLogin() {
  if (window.location.pathname === '/login') return
  localStorage.removeItem('todo_token')
  try { router.replace('/login') } catch (e) { window.location.href = '/login' }
}

function toast(msg, type = 'warn') {
  window.dispatchEvent(new CustomEvent('todo-toast', { detail: { msg, type } }))
}

service.interceptors.request.use(config => {
  const token = localStorage.getItem('todo_token')
  if (token) config.headers['Authorization'] = 'Bearer ' + token
  return config
})

service.interceptors.response.use(
  res => {
    if (res.config.responseType === 'blob') return res
    const data = res.data
    if (data.code !== undefined && data.code !== 200) {
      if (data.code === 401) {
        gotoLogin()
        return Promise.reject(null)
      }
      toast(data.msg || '请求失败', 'error')
      return Promise.reject(null)
    }
    return data
  },
  err => {
    if (err.response && err.response.status === 401) {
      gotoLogin()
      return Promise.reject(null)
    }
    const isNetwork = !err.response
    toast(isNetwork ? '服务连接中，请稍候重试…' : (err.response?.data?.msg || err.message || '请求失败'),
          isNetwork ? 'warn' : 'error')
    return Promise.reject(null)
  }
)

export default service